<template lang="html">
  <div class="page-container">
    <UiModal
      v-if="transactionDetails"
      @close="transactionDetails = null"

      title="Detalii tranzacție"
      :subtitle="`ID: ${ transactionDetails.id }`"

      :buttons="[
        {
          event: 'close',
          text: 'Închide'
        }
      ]"
    >
      <template v-slot:body>
        <h3 class="transaction__subtitle">
          {{ transactionDetails.details.title }}
        </h3>

        <div class="metadata">
          <div class="metadata__item">
            Nume client
            <span>
              {{ transactionDetails.details.client_name }}
            </span>
          </div>

          <div class="metadata__item">
            ID Client
            <span>
              {{ transactionDetails.details.client_id }}
            </span>
          </div>

          <div class="metadata__item">
            ID Programare
            <span v-if="transactionDetails.details.appointment_id == null">
                Ședință pe loc
            </span>
            <span v-else>
              {{ transactionDetails.details.appointment_id }}
            </span>
          </div>

          <div class="metadata__item">
            Dată Programare
            <span>
              {{ transactionDetails.details.appointment_date | moment('dd DD.MM.YYYY') }}
            </span>
          </div>

          <div class="metadata__item">
            Ora Programare
            <span>
              {{ transactionDetails.details.appointment_date | moment('HH:mm') }}
            </span>
          </div>

          <div class="metadata__item">
            Durată sesiune
            <span v-if="transactionDetails.details.appointment_id != null">
              {{ transactionDetails.details.appointment_services * 30 }} min
            </span>
            <span v-else>
              {{ transactionDetails.details.duration }} min
            </span>
          </div>

          <div class="metadata__item">
            Ședințe alocate
            <span v-if="transactionDetails.details.appointment_id == null">
                Ședință pe loc
            </span>
            <span v-else>
              {{ transactionDetails.details.appointment_services }}
            </span>
          </div>
        </div>
      </template>
    </UiModal>


    <div class="page-container__header">
      <h1 class="header-1 page-container__title">
        Istoric tranzacții
      </h1>
      <div class="page-container__header__list-type">
        <i
          class="fas fa-list-ul"
          :class="{ active: transactionsAppearance === 'list' }"
          @click="changeTransactionsAppearance('list')"
        />
        <i
          class="fas fa-border-all"
          :class="{ active: transactionsAppearance === 'grid' }"
          @click="changeTransactionsAppearance('grid')"
        />
      </div>
    </div>
    <div class="page-container__body">
      <p v-if="transactionsLoading === false && transactions.length === 0">
        Nu ai nici o tranzacție.
      </p>

      <div class="page__wrapper" :class="{ 'page__wrapper--list': transactionsAppearance === 'list' }" v-else>
        <TransactionCard
          v-for="(transaction, index) of transactions"
          @openDetails="openDetails"

          :key="transaction.id"
          :appearance="transactionsAppearance"
          :index="index"
          :transaction="transaction"
        />

        <template v-if="transactionsLoading">
          <TransactionCard :appearance="transactionsAppearance" :skeleton="true" />
          <TransactionCard :appearance="transactionsAppearance" :skeleton="true" />
          <TransactionCard :appearance="transactionsAppearance" :skeleton="true" />
        </template>
      </div>


      <div v-if="!(transactionsLoading)" style="margin-top: 30px; text-align: center; width: 100%;">
        <p v-if="transactionsEnd">
          Nu mai sunt tranzacții de încărcat.
        </p>

        <UiButton @click="fetchTransactions" name="Încarcă mai multe" v-else />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TransactionCard            from './components/TransactionCard';
import UiModal                    from '@/components/ui/Modal';
import UiButton                   from '@/components/ui/Button';

export default {
  components: {
    TransactionCard,
    UiModal,
    UiButton
  },
  data() {
    return {
      transactionDetails: null,
    };
  },
  created() {
    window.addEventListener('scroll', this.onScroll, false);
  },
  mounted() {
    if (this.transactions.length === 0) {
      this.fetchTransactions();
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll, false);
  },
  computed: {
    ...mapGetters({
      transactions           : 'specialist/transactions',
      transactionsAppearance : 'specialist/transactionsAppearance',
      transactionsEnd        : 'specialist/transactionsEnd',
      transactionsLoading    : 'specialist/transactionsLoading',
      user                   : 'user/user',
    }),
  },
  methods: {
    ...mapActions({
      changeTransactionsAppearance : 'specialist/changeTransactionsAppearance',
      fetchTransactions            : 'specialist/fetchTransactions',
    }),

    openDetails(transaction) {
      try {
        transaction.details = JSON.parse(transaction.details);
      } catch (error) {}

      this.transactionDetails = transaction;
    },

    onScroll() {
      if (window.innerHeight + window.scrollY + 100 >= document.body.offsetHeight) {
        this.fetchTransactions();
      }
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/pages/appointments';
.transaction__subtitle {
  border-bottom: 1px solid $color-light-gray;
  margin-bottom: 10px;
  margin-top: 40px;
  padding-bottom: 5px;
}

.metadata {
  display: flex;
  flex-direction: column;
  margin-bottom: 35px;

  &__item {
    align-items: center;
    color: $color-gray;
    display: flex;
    flex: 1;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    justify-content: space-between;
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }

    & > span {
      font-weight: 500;
    }
  }
}
</style>
